/**
 * 判断是否为安全的环境
 */

import AppConfig from "@/config/app"
export function isDebugEnv() {
  return ["local", "dev", "test"].includes(AppConfig.env ?? "production")
}
